module.exports = __webpack_public_path__ + "static/media/i_appstore_fr.5723b1c6.svg";